import { CommonApi } from "../../common/api/CommonApi";
import { ApiManager } from "../api/ApiManager";

export const addManager = async (addData) => {
  try {
    const data = await CommonApi().addUser(
      {
        ...addData,
        roleType: "Manager"
      }
    );

    if (data.success) {
      return { success: true, data: data.response };
    } else {
      return { success: false, data: data.errors };
    }
  } catch (error) {
    return { success: false, data: error };
  }
};

export const getManagers = async () => {
  try {
    const data  = await ApiManager().getManager();

    if (data.success) {
      return { success: true, data: data.response };
    } else {
      return { success: false, data: data.errors };
    }
  } catch (error) {
    return { success: false, data: error };
  }
};